// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-element{position:relative;width:100%;height:100%}.media-element.is_covered img,.media-element.is_covered video{-o-object-fit:cover;object-fit:cover}.media-element .media-color{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
